import * as React from "react";
import PropTypes from "prop-types";
import DetailsSection from "nexia_mobile/components/Details/DetailsSection";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";

const DetailsControlWrapper = ({ children }) => {
  let controlStyle = {
    fontSize: "1.5em",
    maxWidth: "20em",
    margin: "0 auto",
  };
  return (
    <ErrorHandler>
      <div
        data-component-name="DetailsControlsWrapper"
        style={{ textAlign: "center" }}
      >
        <DetailsSection style={controlStyle}>{children}</DetailsSection>
      </div>
    </ErrorHandler>
  );
};
DetailsControlWrapper.propTypes = {
  children: PropTypes.node,
};

export default DetailsControlWrapper;



// WEBPACK FOOTER //
// ./src/components/Controls/wrappers/DetailsControlWrapper.jsx